import { z } from "zod";

export const cpfSchema = z
  .string()
  .transform((value) => value.replace(/\D/g, ""))
  .refine((value) => value.length === 11, "CPF deve conter 11 dígitos.");

export const phoneSchema = z
  .string()
  .transform((value) => value.replace(/\D/g, ""))
  .refine((value) => value.length >= 10 && value.length <= 13, "Telefone inválido.");

export const personInputSchema = z.object({
  fullName: z.string().trim().min(3).max(160),
  cpf: cpfSchema.optional(),
  birthDate: z.iso.date().optional(),
  email: z.email().optional(),
  phone: phoneSchema.optional(),
  relationship: z.string().trim().max(80).optional(),
  roles: z.array(
    z.enum([
      "CONTRACTING_PARTY",
      "PRIMARY_HOLDER",
      "SECONDARY_HOLDER",
      "DEPENDENT",
      "FINANCIAL_RESPONSIBLE",
      "SIGNER",
      "TELEMEDICINE_BENEFICIARY",
    ]),
  ),
  billable: z.boolean(),
  funeralCovered: z.boolean(),
  telemedicineCovered: z.boolean(),
});

export const salesIntentSchema = z.object({
  externalEventId: z.string().min(1),
  externalLeadId: z.string().min(1),
  externalSellerId: z.string().min(1),
  externalCampaignId: z.string().optional(),
  customer: z.object({
    name: z.string().min(3),
    phone: phoneSchema,
    email: z.email().optional(),
  }),
  interestedProducts: z
    .array(z.enum(["FUNERAL", "TELEMEDICINE"]))
    .min(1)
    .max(2),
  metadata: z.record(z.string(), z.unknown()).default({}),
});

export type PersonInput = z.infer<typeof personInputSchema>;
export type SalesIntentInput = z.infer<typeof salesIntentSchema>;
